var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluild":""}},[(_vm.loadingCompany || _vm.loadingUsers)?_c('Loading'):_c('TabViews',{attrs:{"vertical":false,"centered":false,"tabs":_vm.companyTabs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }